module.exports = __webpack_public_path__ + "img/transfer22.88d5213d.jpeg";